<template lang="pug">
header.header
    div.header__sidebar.d-flex.d-sm-none
        i.fas.fa-bars.toggle(
            v-b-toggle.sidebar-2
        )
    div.header__brand.d-none.d-sm-block(@click="reset")  {{ $t("app.delivery") }}
    div.header__main
        template(v-if='this.appSetting.useFeatureTakeaway')
            div.header-location( @click="showChangeStoreDialog()" )
                label {{$t("button.ChooseStore")}}
                i.fas.fa-location-arrow
        div.dropdown.d-none.d-sm-block
            button.dropbtn(
                @click="openAccount()"
            )  {{ loginText }}
            template(v-if="auth.currentUser")
                div.dropdown-content
                    a( @click="toYourOrder") {{ $t("auth.title-yourOrder") }}
                    a( @click="toEditProfile") {{ $t("auth.title-updateAccount")}}
                    a( @click="toUpdatePassword") {{ $t("auth.title-updatePassword") }}
                    a( v-if="appSetting.useFeatureAddressManage" @click="toManageAddress") {{ $t("auth.title-addressManagement") }}
                    a( @click="toOrderHistory") {{ $t("auth.title-orderHistory")}}
                    a( @click="toIndividualPromotion") {{ $t("auth.title-your-promotion") }}
                    a( v-if="appSetting.useMembership" @click="toMembership")  {{ $t("auth.title-membership") }}
                    a( v-if="appSetting.useCrmPromotion" @click="toPromotion") {{$t("auth.title-redeemPromotion") }}
                    a( v-if="appSetting.useFavoriteMenu" @click="toYourFavorite") {{ $t("auth.title-yourFavorite") }}
                    a( @click="logout") {{ $t("button.logout") }}


        div.cart-btn( v-if="showCart")  
            i( v-if="isOrdering" class="fas fa-store" @click="showInfoDelivery()")
            i.fas.fa-shopping-bag( @click="openCart()") 
                div(v-if="cartCount > 0") 
                    template(v-if="cartCount > 0")  {{ cartCount }}
       
        div.language-option.d-none.d-sm-block
            input(
                id="toggle-en"
                name="toggle-en"
                type="radio"
                :checked="language == 'en'"
                @click="switchLanguage('en')"
            )
            label(
                for="toggle-en" 
                :class="[language === 'en' ? 'active' : '']"
            ) {{ "EN" }}

            input(
                id="toggle-vi"
                name="toggle-vi"
                type="radio"
                :checked="language === 'vi'"
                @click="switchLanguage('vi')"
            )
            label(
                for="toggle-vi"  
                :class="[language === 'vi' ? 'active' : '']"
            ) {{ "VI" }}

            input(
                id="toggle-ja"
                name="toggle-ja"
                type="radio"
                :checked="language === 'ja'"
                @click="switchLanguage('ja')"
            )
            label(
                for="toggle-ja" 
                :class="[language === 'ja' ? 'active' : '']"
            ) {{ "JP" }}

        div.header-qr.d-none.d-sm-block( @click="openScanner" )
            i.fas.fa-qrcode
       
            
        b-modal(
            id="qr-scan"
            hide-header-close
            no-close-on-backdrop
            centered
            hide-footer
            :title="$t('deliveryInfo.modalQRTitle')"
        )
            qrcode-stream.showQRCode( @decode="onDecode" )   
        b-modal(
            id="modal-delivery-info"
            hide-header-close
            centered
            hide-footer
            :title="title"
        )     
            div.testimonial-box
                p.my-0
                    b {{ deliveryDataGet.storeName }}
                p.my-0 {{ deliveryDataGet.orderFrom }}
                hr
                div( v-if='deliveryDataGet.deliveryTo !== "" ')
                p.my-0
                    b {{ $t("deliveryInfo.deliveryTo") }}

        b-modal.custom(
            id="modal-choosing-store"
            :title='this.$t("button.ChooseStore")'
            centered
            size="xl"
            @ok="handleOk"
            @cancel="hideChangeStoreDialog"
        )     
            b-form-select(
                
                v-model="id" 
                :options="storeDescriptionField"
                size="lg"
                @input = 'onchangeStore(id)'

            )
              





</template>



<!-- <template>
    <header class="header">
        <div class="header__sidebar d-flex d-sm-none">
            <i class="fas fa-bars toggle" v-b-toggle.sidebar-2></i>
        </div>
        <div class="header__brand d-none d-sm-block" @click="reset">
            {{ $t("app.delivery") }}
        </div>
        <div class="header__main">
            <div class="dropdown  d-none d-sm-block">
                <button class="dropbtn" @click="openAccount()">
                    {{ loginText }}
                </button>
                <div v-if="auth.currentUser" class="dropdown-content">
                    <a @click="toYourOrder">{{ $t("auth.title-yourOrder") }}</a>
                    <a @click="toEditProfile">{{
                        $t("auth.title-updateAccount")
                    }}</a>
                    <a @click="toUpdatePassword">{{
                        $t("auth.title-updatePassword")
                    }}</a>
                    <a
                        v-if="appSetting.useFeatureAddressManage"
                        @click="toManageAddress"
                        >{{ $t("auth.title-addressManagement") }}</a
                    >
                    <a @click="toOrderHistory">{{
                        $t("auth.title-orderHistory")
                    }}</a>
                     <a @click="toIndividualPromotion">{{
                        $t("auth.title-your-promotion")
                    }}</a>
                    <a
                        v-if="appSetting.useMembership"
                        @click="toMembership"
                        >{{ $t("auth.title-membership") }}</a
                    >
                    <a v-if="appSetting.useCrmPromotion" @click="toPromotion">{{
                        $t("auth.title-redeemPromotion")
                    }}</a>
                    <a
                        v-if="appSetting.useFavoriteMenu"
                        @click="toYourFavorite"
                        >{{ $t("auth.title-yourFavorite") }}</a
                    >
                    <a @click="logout">{{ $t("button.logout") }}</a>
                </div>
            </div>
            <div v-if="showCart" class="cart-btn">
                <i
                    v-if="isOrdering"
                    class="fas fa-store"
                    @click="showInfoDelivery()"
                />
                <i class="fas fa-shopping-bag" @click="openCart()">
                    <div v-if="cartCount > 0">
                        <template v-if="cartCount > 0">
                            {{ cartCount }}
                        </template>
                     
                    </div>
                </i>
            </div>
            <div class="language-option  d-none d-sm-block">
                <input
                    id="toggle-en"
                    name="toggle-en"
                    type="radio"
                    :checked="language == 'en'"
                    @click="switchLanguage('en')"
                />
                <label for="toggle-en" :class="language == 'en' ? 'active' : ''"
                    >EN
                </label>
                <input
                    id="toggle-vi"
                    name="toggle-vi"
                    type="radio"
                    :checked="language == 'vi'"
                    @click="switchLanguage('vi')"
                />
                <label for="toggle-vi" :class="language == 'vi' ? 'active' : ''"
                    >VI</label
                >
                <input
                    id="toggle-ja"
                    name="toggle-ja"
                    type="radio"
                    :checked="language == 'ja'"
                    @click="switchLanguage('ja')"
                />
                <label for="toggle-ja" :class="language == 'ja' ? 'active' : ''"
                    >JP
                </label>
            </div>
            <div class="header-qr  d-none d-sm-block" @click="openScanner">
                <i class="fas fa-qrcode"></i>
            </div>
        </div>

        <b-modal
            id="qr-scan"
            hide-header-close
            no-close-on-backdrop
            centered
            hide-footer
            :title="$t('deliveryInfo.modalQRTitle')"
        >
            <qrcode-stream class="showQRCode" @decode="onDecode" />
        </b-modal>

        <b-modal
            id="modal-delivery-info"
            hide-header-close
            centered
            hide-footer
            :title="title"
        >
            <div class="testimonial-box">
                <p class="my-0">
                    <b>{{ deliveryDataGet.storeName }}</b>
                </p>
                <p class="my-0">{{ deliveryDataGet.orderFrom }}</p>
                <hr/>
                <div v-if='deliveryDataGet.deliveryTo !== "" '>
                    <p class="my-0">
                        <b>{{ $t("deliveryInfo.deliveryTo") }}</b>
                        <br/>
                        <hr/>
                    </p>                
                    <p  class="my-0"> {{ deliveryDataGet.deliveryTo }}</p>
                </div>
               
                <p class="my-0">
                    {{ $t("deliveryInfo.OrderTime") + ":" }}
                    {{ deliveryDataGet.orderTime | formatTime }}
                </p>
                <p class="my-0">
                    {{ $t("deliveryInfo.estimatedDeliveryTime") + ": " }}
                    {{ deliveryDataGet.servsTime | formatTime }}
                </p>
            </div>
        </b-modal>
    </header>
</template> -->

<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import accountManageRoute from "@/components/mixins/accountManageRoute";
import DeliveryAddressInput from "@/views/DeliveryAddressInput.vue";
import CustomerAPI from "@/api/customer";
import popup from "@/components/mixins/popup";
import StoreSelectBox from "@/components/common/StoreSelectBox.vue";

export default {
    name: "Header",
    components: { 
        DeliveryAddressInput,
        StoreSelectBox 
    },
    mixins: [accountManageRoute, popup],
    filters: {
        formatTime(value) {
            if (value == undefined || value == "") return "";
            return moment(String(value)).format("HH:mm");
        }
    },

    data() {
        return {
            allStore: [],
            storeSelected: null,
            storeDescriptionField: null,
            id: 0,
        };
    },

    watch: {
        $route(to, from) {
           
            if (this.appMisc.allStore.length > 0) {
                this.storeDescriptionField = this.appMisc.allStore.map(x => {
                    return {
                        value: x.id,
                        text: `(${x.name}) ${x.description}`
                    };
                });
        

            }  
            if (this.selectedStoreGet) {
                this.id = this.selectedStoreGet.id
            }
            if (from.name === "DeliveryAddressInput" &&  to.name === 'MainMenu') {
                this.id= this.appMisc.defaultStoreID

                if (this.appSetting.useFeatureTakeaway) {
                    this.showChangeStoreDialog()
                }    
                
            }
           
            
        }
    },


    async created() {
        
        
        this.deliveryEstimate = moment(this.deliveryDataGet.orderTime).add(
            1,
            "hour"
        );

        // get default language
        if (!this.language) {
            let language = await this.$store.dispatch('language/getDefaultLanguage');
            this.switchLanguage(language);
        } else {
            this.switchLanguage(this.language);
        }


    },




   
  

    computed: {
        ...mapState(["auth"]),
        ...mapGetters([
            "showCart",
            "cartCount",
            "deliveryDataGet",
            "selectedStoreGet"
        ]),
        ...mapGetters({
            appSetting: "settingGet",
            appMisc: "miscGet"
        }),
        ...mapGetters({
            language: "language/language",
        }),

        loginText() {
            if (this.auth.currentUser) {
                const fullname = this.auth.currentUser.full_name.split(" ");
                return fullname[fullname.length - 1];
            }
            return this.$t("auth.title-login");
        },

        isOrdering() {
            if (this.deliveryDataGet.orderId) return true;
            return false;
        },

        title() {
            return `${this.$t("deliveryInfo.yourOrderNo")}: #${
                this.deliveryDataGet.orderNo
            }`;
        },

        currentRouteName() {
            return this.$route.name;
        }
    },

    methods: {
        showChangeStoreDialog() {
            this.$bvModal.show("modal-choosing-store");
        },
        hideChangeStoreDialog() {
            this.$bvModal.hide("modal-choosing-store");
        },



        onchangeStore(storeID) {

            this.storeSelected = this.appMisc.allStore.filter(
                x => x.id === storeID
            );
            this.storeSelected =  this.storeSelected[0];
        },
        handleOk()
        {
            this.$store.commit("setSelectedStore", this.storeSelected);
            this.$store.commit("cartSetStore", this.storeSelected);
            this.$root.$emit("changeStore", this.storeSelected);
            this.$store.dispatch("checkMenuAvailability", { vm: this, optionsBox: this.messageBoxOKsizeXXL })
                            .finally(() => { this.loading = false });
            this.hideInfoDelivery();
        },

        openCart() {
            return this.$router.push("/my-cart/").catch(() => {});
        },

        showInfoDelivery() {
            this.$bvModal.show("modal-delivery-info");
        },

        hideInfoDelivery() {
            this.$bvModal.hide("modal-delivery-info");
        },

        switchLanguage(language) {
            this.$store.commit("language/setLanguage", language);
            this.$store.commit("applyMisc", {
                ...this.appMisc,
                language: language
            });
            this.$i18n.locale = language;
            this.$root.$emit("changeLanguage", language);
        },

        openAccount() {
            if (!this.auth.currentUser) {
                return this.$router.push("/login/");
            }
            // return this.$router.push("/profile/");
        },

        reset() {
            this.$store.commit("favorite/resetState");
            window.location = "/";
        },

        async logout() {
            await this.$store.dispatch("auth/customerLogout");
        },

        openScanner() {
            this.$bvModal.show("profile-scan");
        },

        onDecode(result) {
            CustomerAPI.scanEventQRCode({ code: result })
                .then(({ data }) => {
                    if (data.valid) {
                        this.$bvModal.msgBoxOk(
                            this.$t("promotion.message-promotionAdded"),
                            this.messageBoxOk
                        );
                    }

                    if (!data.valid) {
                        this.$bvModal.msgBoxOk(data.reason, this.messageBoxOk);
                    }

                    this.$bvModal.hide("profile-scan");
                })
                .catch(err => {
                    this.$bvModal.msgBoxOk(
                        err?.response?.code,
                        this.messageBoxOk
                    );
                    this.$bvModal.hide("profile-scan");
                });
        }
    },

        mounted() {
        {
             if (this.appMisc.allStore.length > 0) {
                this.storeDescriptionField = this.appMisc.allStore.map(x => {
                    return {
                        value: x.id,
                        text: `(${x.name}) ${x.description}`
                    };
                });
        

            }  
            if (this.selectedStoreGet) {
                this.id = this.selectedStoreGet.id
            }
            // console.log(this.id);

        }
    },
    
};

</script>

<style lang="scss" scoped>
.header__logo {
    background: url(../../assets/logo/delivery.png) no-repeat;
    background-size: contain;
    background-position-y: center;
}
</style>
